import { useApiMutation, useApiQuery } from "@/lib/query";
import type { Connection, ConnectionCheck, ConnectionCreate, ConnectionUpdate } from "./types";

// A key array, not a path: the lists only, not the discovery reads under `/connections/{id}/…`.
const LISTS = [["/connections"]];

export const useConnections = (connectorType = "") =>
  useApiQuery<Connection[]>("/connections", { connector_type: connectorType });

/**
 * Saving a connection sends its secret, so the mutation is dropped from the
 * cache as soon as nothing shows it (`gcTime: 0`), not kept for minutes.
 */
export const useCreateConnection = () =>
  useApiMutation<Connection, ConnectionCreate>("post", "/connections", { invalidate: LISTS, gcTime: 0 });

/** Editing may change what discovery returns, so that connection's reads refetch too. */
export const useUpdateConnection = (id: string) =>
  useApiMutation<Connection, ConnectionUpdate>("patch", `/connections/${id}`, {
    invalidate: [...LISTS, `/connections/${id}`],
    gcTime: 0,
  });

/** The outcome is saved on the connection, so the lists refetch to show it. */
export const useCheckConnection = () =>
  useApiMutation<ConnectionCheck, string>("post", (id) => `/connections/${id}/check`, {
    invalidate: LISTS,
  });
